import Bugsnag from "@bugsnag/js";
import Vue from "vue";
import VueApollo from "vue-apollo";
import { createApolloClient, restartWebsockets } from "vue-cli-plugin-apollo/graphql-client";
import provider from "./libs/provider";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { v1 as uuidv1 } from 'uuid';

// Install the vue plugin
Vue.use(VueApollo);

// Name of the localStorage items
const AUTH_TOKEN = "apollo-token";

// Config
const defaultOptions = {
	// LocalStorage token
	tokenName: AUTH_TOKEN,
	// Enable Automatic Query persisting with Apollo Engine
	persisting: false,
	// Use websockets for everything (no HTTP)
	// You need to pass a `wsEndpoint` for this to work
	websocketsOnly: false,
	// Is being rendered on the server?
	ssr: false,

	// Override default apollo link
	// note: don't override httpLink here, specify httpLink options in the
	// httpLinkOptions property of defaultOptions.
	httpLinkOptions: {
		headers: { "x-provider-code": provider.get().providerCode, "x-session-id": uuidv1() }
	},

	// Override default cache
	cache: new InMemoryCache(),

	// Override the way the Authorization header is set
	// getAuth: (tokenName) => ...

	// Additional ApolloClient options
	// apollo: { ... }

	// Client local data (see apollo-link-state)
	// clientState: { resolvers: { ... }, defaults: { ... } }
};

// Call this in the Vue app file
export function createProvider(options = {}) {
	// Create apollo client
	const { apolloClient, wsClient } = createApolloClient({
		httpEndpoint: getUri(),
		...defaultOptions,
		...options
	});
	apolloClient.wsClient = wsClient;

	// Create vue apollo provider
	const apolloProvider = new VueApollo({
		defaultClient: apolloClient,
		defaultOptions: {
			$query: {
				// fetchPolicy: 'cache-and-network',
			}
		},
		errorHandler(error) {
			// eslint-disable-next-line no-console
			console.log("%cError", "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;", error.message);
		}
	});

	return apolloProvider;
}

// Decide which regional endpoint to use
function getUri() {
	const region = localStorage.getItem("graphql-region") || "GBR";
	return { GBR: process.env.VUE_APP_GRAPHQL_HTTP, AUS: process.env.VUE_APP_GRAPHQL_HTTP_AUS, ZAF: process.env.VUE_APP_GRAPHQL_HTTP_ZAF }[region];
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
	if (typeof localStorage !== "undefined" && token) {
		localStorage.setItem(AUTH_TOKEN, token);
	}
	if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
	try {
		await apolloClient.resetStore();
	} catch (e) {
		// eslint-disable-next-line no-console
		Bugsnag.notify(e);
		console.log("%cError on cache reset (login)", "color: orange;", e.message);
	}
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
	if (typeof localStorage !== "undefined") {
		localStorage.removeItem(AUTH_TOKEN);
		localStorage.removeItem("graphql-region");
		//remove all filters
		for (const key of Object.keys(localStorage)) { 
			if (key.includes("-filter")) {
				localStorage.removeItem(key);
			}
		}
	}
	if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
	try {
		await apolloClient.resetStore();
	} catch (e) {
		// eslint-disable-next-line no-console
		Bugsnag.notify(e);
		console.log("%cError on cache reset (logout)", "color: orange;", e.message);
	}
}
